import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {OzowPaymentUpdateRequest} from "../../../interfaces/ozow/ozow";
import {OzowService} from "../../../services/ozow/ozow.service";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-ozow-callback',
  templateUrl: './ozow-callback.component.html',
  styleUrls: ['./ozow-callback.component.scss']
})
export class OzowCallbackComponent implements OnInit {

  constructor(private route: ActivatedRoute, private ozowService: OzowService, private router: Router, private breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });
  }

  ozowPaymentUpdateRequest: OzowPaymentUpdateRequest
  confirmed: boolean = false;
  mobile;
  cardSvgEl;

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.ozowPaymentUpdateRequest = {
          siteCode: params.SiteCode,
          transactionId: params.TransactionId,
          transactionReference: params.TransactionReference,
          amount: params.Amount,
          status: params.Status,
          currencyCode: params.CurrencyCode,
          isTest: params.IsTest,
          statusMessage: params.StatusMessage,
          bankName: params.BankName,
          hash: params.Hash
        }

      this.ozowService.update(sessionStorage.getItem('sessionToken'), this.ozowPaymentUpdateRequest)
      .subscribe(
        value => {
          console.log('Response : '+ value)
          this.confirmed = true;
          this.navigateToStatus();
        }, (err: HttpErrorResponse) => {
          this.navigateToStatus();
        }
      );
      }
    );
  }


  navigateToStatus() {
    this.router.navigate(
      [`transaction-status`]);
  }

}
